import React, { useEffect, useMemo, useState } from "react";

import * as S from "./styles";

import Chart from "react-apexcharts";
import {
  CustomChartContainer,
  CustomChartHeader,
  CustomChartTitle,
} from "../styles";
import { CircularProgress } from "@mui/material";

var options = (data) => ({
  chart: {
    // height: 350,
    id: "chart-desempenho",
    type: "area",
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    foreColor: "#000000",
    fontSize: "10px",
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
  },
  dataLabels: {
    enabled: true,
    offsetY: -10,
    background: {
      enabled: false,
    },
    style: {
      fontSize: "10px",
      fontFamily: "Inter, Helvetica, Arial, sans-serif",
      // fontWeight: 'bold',
      colors: ["#666666"],
    },
  },
  grid: {
    show: true,
    borderColor: "#ccc",
    strokeDashArray: 0,
    position: "back",
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
    row: {
      colors: undefined,
      opacity: 0.5,
    },
    column: {
      colors: undefined,
      opacity: 0.5,
    },
  },
  yaxis: {
    // title: {
    //   text: "$ (thousands)",
    // },
    labels: {
      show: true,
    },
  },
  stroke: {
    curve: "smooth",
    width: 3,
    colors: ["#F26A1D"],
  },
  // resizable: true,
  tooltip: {
    enabled: false,
  },
  legend: {
    showForSingleSeries: true,
    colors: "#F26A1D",
    horizontalAlign: "left",
    fontSize: "12px",
    fontFamily: "Poppins, Helvetica, Arial",
    fontWeight: 400,
    labels: {
      colors: "#000000",
      offsetX: 10,
    },
    markers: {
      size: 4,
      shape: undefined,
      strokeWidth: 0,
      fillColors: "#F26A1D",
      customHTML: undefined,
      onClick: undefined,
      offsetX: -5,
      offsetY: 0,
    },
    offsetX: 0,
  },
});

const DesempenhoGraphic = ({ data, isLoadingData }) => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 643,
      }}
    >
      <CustomChartContainer>
        <CustomChartHeader>
          <CustomChartTitle>Desempenho</CustomChartTitle>
        </CustomChartHeader>
        <S.ChartWrapper id="desempenho-container">
          {isLoadingData ? (
            <CircularProgress style={{ color: "#F9922A" }} thickness={5} />
          ) : (
            <Chart
              options={{
                ...options(data),
                markers: {
                  size: 3,
                  colors: "#F26A1D",
                  strokeColors: "#F26A1D",
                  strokeWidth: 3,
                  strokeOpacity: 0.9,
                  strokeDashArray: 0,
                },
                colors: ["#F26A1D"],
                fill: {
                  colors: ["#F26A1D"],
                  opacity: 0.9,
                  type: "gradient",
                  gradient: {
                    type: "vertical",
                    shadeIntensity: 0,
                    // gradientToColors: undefined,
                    // inverseColors: true,
                    // opacityFrom: 1,
                    // opacityTo: 1,
                    // stops: [0, 50, 100],
                    // colorStops: []
                  },
                },
                xaxis: {
                  categories: data.xaxis.categories,
                },
              }}
              series={data.series}
              width="100%"
              type="area"
              height={410}
            />
          )}
        </S.ChartWrapper>
      </CustomChartContainer>
    </div>
  );
};

export default DesempenhoGraphic;
